'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComment = exports.commentsPrefixUrl = undefined;

var _immutable = require('immutable');

var commentsPrefixUrl = exports.commentsPrefixUrl = function commentsPrefixUrl(fid, eid, aid, pid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/events/' + eid + '/adjudicators/' + aid + '/persons/' + pid + '/comments';
};

var getComment = exports.getComment = function getComment(state, cid) {
  return state.getIn(['comments', 'one', cid]) || (0, _immutable.Map)();
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/comments/paths.js
// module id = 49
// module chunks = 0